 document.addEventListener("DOMContentLoaded", function(event) {
   let width = window.innerWidth;
    if(width > 749){
    let swipers = document.querySelector('.slider--desktop');
    if(swipers){
     
        swipers.classList.add('swiper');
        swipers.classList.add('imgSwiper');
    }
    let wrapper = document.querySelector('.product__media-list.flex');
    if(wrapper){
     
        wrapper.classList.add('swiper-wrapper');
    }
    let slides = document.querySelectorAll('.product__media.card');
    if(slides){
      if(width < 750 )
        slides.forEach(e=>{e.classList.remove('mobile:media--adapt_first')});
        slides.forEach(e=>{e.classList.add('swiper-slide')});
    }
      
     let thumbswiper = document.querySelector('.product__thumbnails');
    if(thumbswiper)
    {
       console.log('swiper');
      thumbswiper.classList.add('swiper');
      thumbswiper.classList.add('thumbSwiper');
    }
    let thumbwrap = document.querySelector('.product__thumbnails-list');
    if(thumbwrap)
    {
       console.log('wrap');
      thumbwrap.classList.add('swiper-wrapper');
      thumbwrap.classList.remove('w-full');
      thumbwrap.classList.remove('scroll-area');
    }
    let thumbs = document.querySelectorAll('.product__thumbnails-list .product__thumbnail');
    if(thumbs)
    {
      console.log('slide');
      thumbs.forEach(e => { e.classList.add('swiper-slide')});
    }
    }

  });
 document.addEventListener("DOMContentLoaded", function(event) {
    let thumbSwiper = new Swiper('.thumbSwiper', {
      slidesPerView: 5,
      spaceBetween: 10,
      loop: true,
      freeMode: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      slideToClickedSlide: true,
    });

    let imgSwiper = new Swiper('.imgSwiper', {
      loop: true,
      spaceBetween: 10,
      autoplay: {
        delay: 6000,
        disableOnInteraction: false,
      },
      on: {
        slideChange: function() {
          // Adjust the index based on the loop mode
          const adjustedIndex = this.realIndex % this.slides.length;
          thumbSwiper.slideToLoop(adjustedIndex, 0, false);
        }
      }
    });

    document.querySelectorAll('.thumbSwiper .swiper-slide').forEach((slide) => {
      slide.addEventListener('click', function() {
        const index = parseInt(this.getAttribute('data-swiper-slide-index'));
        imgSwiper.slideToLoop(index, 0, false);
      });
    });

    // Synchronize initial state
    imgSwiper.on('init', () => {
      const adjustedIndex = imgSwiper.realIndex % imgSwiper.slides.length;
      thumbSwiper.slideToLoop(adjustedIndex, 0, false);
    });

    imgSwiper.init();
    thumbSwiper.init();
  });